<template>
    <div>
        <b-container fluid>
            <h3 class="mt-3 mb-3">Tracking Return Process</h3>

            <div class="row">
                <!-- <div class="col-2 pr-0">
                    <b-form-select size="sm" v-model="returned_update_obj.client_selected" :options="client_options" />
                </div>
                <div class="col-2 pr-0">
                    <b-form-input id="input-small" size="md" type="date"
                        v-model="returned_update_obj.collection_date"></b-form-input>
                </div>
                <div class="col-2 pr-0">
                    <b-form-input size="md" type="text" v-model="returned_update_obj.tracking_location"
                        placeholder="Tracking Return Process" />
                </div> -->

                <div class="col-3 pr-0">
                    <b-form-input size="md" type="text" v-model="returned_update_obj.tracking_number"
                        v-on:keyup.enter="onSubmit(returned_update_obj.tracking_number)" placeholder="Tracking #" />
                </div>

                <div class="col-3">
                    <b-button class="btn-action" size="md" variant="info"
                        @click="onSubmit(returned_update_obj.tracking_number)"
                        :disabled="!returned_update_obj.tracking_number" v-if="checkPermission(
                        $store.state.user_obj,
                        'Delivery Management',
                        'Tracking Return Process',
                        'Tracking Return Process',
                        true
                    )
                        ">Submit</b-button>

                    <b-button v-if="checkPermission(
                        $store.state.user_obj,
                        'Delivery Management',
                        'Tracking Return Process',
                        'Tracking Return Process',
                        true)" class="btn-action ml-2" size="md" variant="info" @click="openScanner">Scan</b-button>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col">
                    <b-alert :show="alert_config.show" :variant="alert_config.variant"
                        @dismissed="alert_config.show = false" dismissible>
                        {{ alert_config.message }}
                    </b-alert>
                </div>
            </div>

            <div class="row m-1" v-if="scannerOn">
                <b-button block class="btn-action mb-1" size="md" variant="danger" @click="closeScanner()"
                    v-if="scannerOn">Close</b-button>
                <StreamBarcodeReader style="width: 100%;" @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
            </div>

            <hr>
            <strong># of Records: {{ total_rows }}</strong>

            <b-row class="mt-2">
                <b-col cols="1" class="pr-0">
                    <b-form-select size="sm" v-model="sel_table_limit" :options="[50, 100, 200, 500]"
                        @change="getTrackings()" />
                </b-col>
                <b-col class="pr-1">
                    <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
                        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
                </b-col>
            </b-row>

            <b-table class="mt-0" responsive small outlined striped hover :items="items" :fields="fields"
                :tbody-tr-class="rowClass">
                <template v-slot:head(chk_box)="data">
                    <b-form-checkbox size="sm" plain id="chkbox_all" value="all"
                        v-model="check_all_rows"></b-form-checkbox>
                </template>
                <template v-slot:cell(chk_box)="data">
                    <b-form-checkbox size="sm" class="chkbox_row" plain :id="'chkbox_row_' + data.index"
                        v-model="data.item.is_checked"></b-form-checkbox>
                </template>
                <template v-slot:cell(status)="data">
                    {{ data.item.status }}
                    <!-- <span v-if="data.item.status_reason"
            >- {{ data.item.status_reason }}</span
          > -->
                    <span v-if="data.item.other_reason">
                        <br />
                        [{{ data.item.other_reason }}]
                    </span>
                </template>

                <template v-slot:cell(attention)="data">
                    <span v-if="!data.item.attention_driver">{{
                        data.item.attention
                    }}</span>
                    <span v-if="data.item.attention_driver">{{
                        data.item.attention_driver
                    }}</span>
                </template>

                <template v-slot:cell(phone)="data">
                    <span v-if="!data.item.phone_driver">{{ data.item.phone }}</span>
                    <span v-if="data.item.phone_driver">{{
                        data.item.phone_driver
                    }}</span>
                </template>

                <template v-slot:cell(tracking_number)="data">
                    <router-link :to="{
                        name: 'tracking_detail',
                        params: { id: data.item.id },
                    }">
                        {{ data.item.tracking_number }}
                    </router-link>
                </template>

                <template v-slot:cell(order_number)="data">
                    <div @click="onClickOrderNumber(data.item)" style="cursor: pointer;">
                        {{ data.item.order_number }}
                    </div>
                </template>

                <template v-slot:cell(carried_by)="data">
                    <span v-if="data.item.carried_by && data.item.carried_by != ''">
                        <span v-if="$store.state.user_obj.account_type != 'client_user'">
                            {{ data.item.carried_by || "-" }}
                        </span>
                        <span v-if="$store.state.user_obj.account_type == 'client_user'">
                            -
                        </span>
                    </span>
                    <span v-if="!(data.item.carried_by && data.item.carried_by != '')">-</span>
                </template>

                <template v-slot:cell(pod_image)="data">
                    <!-- <a
            v-if="data.item.pod_image"
            :href="data.item.pod_image"
            target="_blank"
          >{{data.item.pod_type}}</a>-->
                    <div style="text-align: center" v-if="checkPermission(
                        $store.state.user_obj,
                        'Delivery Management',
                        'Delivery Status',
                        'POD Records',
                        true
                    )
                        ">
                        <b-button class="btn-action" size="sm" variant="info" v-if="!(($store.state.user_obj.user_id == '313'
                        || $store.state.user_obj.user_id == '297'
                        || $store.state.user_obj.user_id == '1012')
                        && data.item.pod_type == 'photo'
                    ) && data.item.pod_image" @click="showPod(data.item)">{{ data.item.pod_type }}</b-button>
                        <span v-if="(($store.state.user_obj.user_id == '313'
                        || $store.state.user_obj.user_id == '297'
                        || $store.state.user_obj.user_id == '1012')
                        && data.item.pod_type == 'photo'
                    ) || !data.item.pod_image">-</span>
                    </div>
                </template>

                <template v-slot:cell(ready_for_packing)="data">
                    <div>
                        <span v-if="data.item.ready_for_packing == '0'" class="dot_red"></span>
                        <span v-if="data.item.ready_for_packing == '1'" class="dot_green"></span>
                    </div>
                </template>

                <template v-slot:cell(schedule_date)="data">
                    <span v-if="!data.item.reschedule_delivery_date">{{
                        displayDate(data.item.schedule_date)
                    }}</span>
                    <span v-if="data.item.reschedule_delivery_date">{{ data.item.reschedule_type }}
                        {{ displayDate(data.item.reschedule_delivery_date) }}</span>
                </template>

                <template v-slot:cell(scheduled_delivery_date)="data">
                    {{ displayDate(data.item.scheduled_delivery_date) }}
                </template>

                <template v-slot:cell(packing_print_at)="data">
                    {{ data.item.packing_print_at || "-" }}
                </template>

                <template v-slot:cell(waybill_print_at)="data">
                    {{ data.item.waybill_print_at || "-" }}
                </template>

                <template v-slot:cell(packing_queues)="data">
                    <div v-if="data.item.packing_queues.length > 0">
                        <ul v-for="(queue, i) in data.item.packing_queues" :key="i">
                            <li>{{ queue.queue_name }}</li>
                        </ul>
                    </div>
                    <div v-if="data.item.packing_queues.length == 0">-</div>
                </template>

                <template v-slot:cell(action)="data">
                    <b-button v-if="checkPermission(
                        $store.state.user_obj,
                        'Delivery Management',
                        'Delivery Status',
                        'Order Detail',
                        true
                    )
                        " class="btn-action" size="sm" variant="info"
                        :to="{ name: 'tracking_detail', params: { id: data.item.id } }">Detail</b-button>

                    <b-button v-if="checkPermission(
                        $store.state.user_obj,
                        'Delivery Management',
                        'Delivery Status',
                        'Print Waybill',
                        true
                    )
                        " class="btn-action" size="sm" variant="info"
                        @click.stop="showModal_printWaybill(data.item)">Print
                        Waybill</b-button>

                    <b-button v-if="false &&
                        checkPermission(
                            $store.state.user_obj,
                            'Delivery Management',
                            'Delivery Status',
                            'Toggle Ready for Packing',
                            true
                        )
                        " class="btn-action" size="sm" variant="info" @click.stop="toogleRFP(data.item)">Toggle Ready
                        For
                        Packing</b-button>

                    <span v-if="$store.state.user_obj.account_type == 'admin' ||
                        $store.state.user_obj.account_type == 'cs'
                        ">
                        <b-button class="btn-action" size="sm" variant="info" @click.stop="returnTracking(data.item)">
                            <font-awesome-icon class="mr-1" icon="undo" />Returned
                        </b-button>

                        <b-button class="btn-action" size="sm" variant="info"
                            @click.stop="showModal_reschedule_tracking(data.item)">
                            <font-awesome-icon class="mr-1" icon="calendar-alt" />Reschedule
                        </b-button>

                        <b-button v-if="data.item.status != 'Cancelled'" class="btn-action" size="sm" variant="danger"
                            @click.stop="showModal_cancelTracking(data.item)">Cancel</b-button>

                        <b-button v-if="data.item.status == 'Cancelled' || data.item.status == 'Hold'
                        " class="btn-action" size="sm" variant="danger"
                            @click.stop="pendingTracking(data.item)">Pending</b-button>

                        <b-button v-if="data.item.status != 'Hold'" class="btn-action" size="sm" variant="danger"
                            @click.stop="showModal_holdTracking(data.item)">Hold</b-button>
                    </span>
                </template>
            </b-table>

            <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
                @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
        </b-container>
    </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
    name: "TrackingReturnProcess",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
    mixins: [apiService, global_function],
    components: {
        barcode: VueBarcode,
        StreamBarcodeReader
    },
    data() {
        return {
            sel_table_limit: 100,
            result: null,
            currentPage: 1,
            table_offset: 0,
            total_rows: 0,
            returned_update_obj: {
                client_selected: "RMW",
                tracking_location: null,
                tracking_number: null,
                collection_date: moment().format("YYYY-MM-DD")
            },
            items: [],

            tracking_returned_list: [],

            scannerOn: false,

            alert_config: {
                show: false,
                variant: "danger",
                message: ""
            },

            client_options: [
                {
                    value: "RMW",
                    text: "RMW",
                },
            ],

            fields: [
                {
                    key: "client_name",
                    label: "Client",
                },
                {
                    key: "order_number",
                    label: "Order#",
                },
                {
                    key: "courier_short_name",
                    label: "Courier",
                },
                {
                    key: "tracking_number",
                    label: "Tracking#",
                },
                {
                    key: "status",
                    label: "Status",
                },
                {
                    key: "scheduled_delivery_date",
                    label: "Scheduled Date",
                },
                {
                    key: "returned_date",
                    label: "Returned Date",
                },
            ],

            camera_cooldown: false,

            search_criteria: {
                keyword: "",
                packing_sector: "",
                status_selected: "Returned_to_Warehouse",
                case_created_by: null,
                has_delivery_case: false,
                has_cs_case: false,
                ready_for_packing: 1,
                start_at: moment().subtract(6, "months").format("YYYY-MM-DD"),
                end_at: moment().format("YYYY-MM-DD"),
                client_selected: null,
                courier_selected: null,
                waybill_status_selected: null,
                tier_selected: null
            },
            loader_full: null
        };
    },
    async created() {
        await this.getTrackings();
        this.initialized = true;
    },
    mounted() { },
    watch: {},
    methods: {
        async onDecode(content) {
            if (this.scannerOn && !this.camera_cooldown) {
                this.result = content;
                this.onSubmit(content);
            }
        },
        onLoaded() {
            console.log("loaded barcode reader");
        },

        onPageChange(page_to_change) {
            this.table_offset = (page_to_change - 1) * this.sel_table_limit;
            this.getTrackings();
        },

        async getTrackings() {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "tracking_get.php",
                data: {
                    offset: this.table_offset,
                    limit: this.sel_table_limit,
                    sort_by_col: this.sort_by_col,
                    sort_by_order: this.sort_by_order,
                    search_criteria: this.search_criteria,
                    account_type: this.$store.state.user_obj.account_type,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                    skip_packing_queue: true
                },
            });
            this.items = response.data.trackings;
            this.total_rows = parseInt(response.data.total_rows);
            if (response.data.trackings && response.data.trackings.length > 0) {
                this.client_name = response.data.trackings[0].client_name;
            }
            this.loader_full.hide();
        },

        rowClass(item, type) {
            if (!item || type !== "row") return;
            if (item.is_checked) return "table-info";
        },

        async onSubmit(tracking_number) {
            this.alert_config = {
                show: false,
                variant: "danger",
                message: ""
            };

            if (!tracking_number || tracking_number === "") return;

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "tracking_update_returned.php",
                data: {
                    tracking_number: tracking_number,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            this.camera_cooldown = true;
            setTimeout(() => (this.camera_cooldown = false), 2000);

            if (response.data.status === "success") {
                this.alert_config = {
                    show: true,
                    variant: "success",
                    message: "Tracking Returned Successfully"
                };
            } else {
                this.alert_config = {
                    show: true,
                    variant: "danger",
                    message: `[${tracking_number}] ${response.data.message}`
                };
            }

            this.returned_update_obj.tracking_number = '';

            this.getTrackings();
        },

        openScanner() {
            this.scannerOn = true;
        },
        closeScanner() {
            this.scannerOn = false;
        },

        displayDate(d) {
            if (d == "0000-00-00") {
                return "-";
            } else if (d) {
                return moment(d).format("YYYY-MM-DD");
            } else {
                return "-";
            }
        },

    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}

.span-status {
    display: none;
}

.container-status:hover .span-status {
    display: inline;
}

.row-status_cnt {
    display: flex;
}

.scanner-container video {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/TrackingReturnProcess.vue